import {isMobile} from '@shopify/app-bridge/utilities';

  export function mobileScreen() {
  //min-width: 48em
  return window.matchMedia("(max-width: 48em)").matches
  }

  //used to change the title to breadcrumb on mobile. so tabs shows the page which you are on
  export function mobileTitle(page, breadcrumb){
    if (mobileScreen()) {
        return breadcrumb;
      } else {
        return page;
      }
  }

  //used to remove breadcrumb on mobile, so there no settings/settings on tablets
  export function mobileBreadcrumb(crumb){
    if (mobileScreen()) {
        return [];
      } else {
        return [{ content: `${crumb}`} ];
      }
  }

  //unsused wanting to combine into one function
  export function titleAndBreadcrumb(title, breadcrumb){
    return {
      title: mobileTitle(title),
      breadcrumb: mobileBreadcrumb(breadcrumb),
    };
  }

  //create tabs from navigation sections for mobile
  export function tabsFromSections(sections){
    var tabs = [];

  if (mobileScreen()) {
    tabs.push({
      label: 'Home',
      url: '/places/*',  // Home tab pointing to /places/*
    });
  }

    if(sections ){//only create if small screen && mobileScreen()
      sections.forEach(section => {
        section.items.forEach((item) => {
          tabs.push(item);
        });
      });

      tabs = tabs.map((tab) => {
        return {
          id: tab.url,
          content: tab.label,
          accessibilityLabel: tab.label,
          panelID: tab.url,
          path: tab.url,
        };

      });
    }

    return tabs;
  }

